import React, { useState, useEffect } from "react";
import "../../styles/sections/financingCard.scss";
import WhatsAppModal from "../WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { saveUtmParams } from "../../config/whatsappConfig";

const FinancingCard = ({
  banco,
  logo,
  color,
  etiquetas,
  titulo,
  tasa,
  tasaDestacada,
  detalle,
  detalleDestacado,
  link,
}) => {
  // Procesar UTM parameters al cargar el componente
  useEffect(() => {
    saveUtmParams();
  }, []);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleWhatsAppClick = () => {
    setOpen(true);
  };

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      await updateData(values);
      setOpen(false);
      // Construir la URL con origen CONSULTA WEB
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("utm_source", "CONSULTA WEB");
      const urlWithUtm = currentUrl.toString();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.location.href = `https://api.whatsapp.com/send?phone=5493517385093&text=${encodedMessage}`;
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="financing-card">
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        {logo && <img src={logo} alt={banco} className="financing-card-logo" />}
      </div>
      <div className="financing-chips-container" style={{ marginBottom: 12 }}>
        {etiquetas &&
          etiquetas.map((et, i) => (
            <span key={i} className="financing-chip">
              {et}
            </span>
          ))}
        {tasaDestacada && <span className="financing-chip tasa">{tasaDestacada}</span>}
      </div>
      <div style={{ marginBottom: 12, marginTop: 12 }}>
        <p className="financing-card-title">
          {titulo}{" "}
          {tasa && (
            <span className="financing-card-tasa">
              {tasa} {detalle && <span className="financing-card-detalle">{detalle}</span>}
            </span>
          )}
        </p>
        {detalleDestacado && <div className="financing-card-detalle-destacado">{detalleDestacado}</div>}
      </div>
      <div>
        <button onClick={handleWhatsAppClick} className="financing-card-btn" disabled={loading}>
          Consultá ahora <span>→</span>
        </button>
      </div>
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
    </div>
  );
};

export default FinancingCard;
